/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';
import { HttpService } from '@angular-kit/core';
import { WorkingHoursRecord, WorkingHoursRecordData } from '@teamworks/global';
import { WorkingHoursService as GlobalWorkingHoursService } from '@teamworks/global';

@Injectable()
export class WorkingHoursService extends GlobalWorkingHoursService {

  constructor(private httpService: HttpService) {
    super();
  }

  async loadWorkingHoursRecordList(employeeId: string): Promise<WorkingHoursRecord[]> {
    return this.httpService.get(`api/time-recording/working-hours-list/${employeeId}`)
      .then((recordDataList: WorkingHoursRecordData[]) => recordDataList
        ? recordDataList.map((recordData) => new WorkingHoursRecord(recordData))
        : null);
  }

  // async saveDefaultWorkingHoursRecordList(employeeId: string, data: WorkingHoursRecordData[]): Promise<void> {
  //   return this.httpService.post(`api/time-recording/working-hours/${employeeId}/default`, data);
  // }

  async loadWorkingHoursRecord(employeeId: string, index: number): Promise<WorkingHoursRecord> {
    return this.httpService.get(`api/time-recording/working-hours/${employeeId}/${index}`)
      .then(savedData => new WorkingHoursRecord(savedData));
  }

  async saveWorkingHoursRecord(data: WorkingHoursRecordData): Promise<WorkingHoursRecord> {
    return this.httpService.post(`api/time-recording/working-hours`, data)
      .then(savedData => new WorkingHoursRecord(savedData));
  }

  async deleteWorkingHoursRecord(employeeId: string, index: number): Promise<WorkingHoursRecord> {
    return this.httpService.delete(`api/time-recording/working-hours/${employeeId}/${index}`)
      .then(savedData => new WorkingHoursRecord(savedData));
  }

}
